import { buildCommunicationNetworkGraphData } from '@web/lib/demo/communicationNetworkGraph/chartData';
export var communicationNetworkGraph = function (input) { return ({
    chart: buildCommunicationNetworkGraphData(input.orgUnitId, input.channel, input.userId)
}); };
